module.exports = __webpack_public_path__ + "static/merch3Back-497401d69e3815312d8c5f7e5836c093.png";